$(function () {

   $(document).on("click", ".send-report-next", function (e) {      
        e.preventDefault(); 
        doSendTrip (getTripDetailRID(),"Send Trip","Send Trip")
    });     
    
   $(document).on("click", ".js-trip-col-index li", function (e) {      
        e.preventDefault(); 
        $(".js-trip-col-index li").removeClass("is-open");
        $(this).addClass("is-open");

        var opens=$(this).attr("href");
        $(".trip-content-detail").removeClass("is-open");
        $(opens).addClass("is-open");
    });     
    
   $(document).on("click", ".btn-trip-add", function (e) {      
        e.preventDefault(); 
        $("." + $(this).data("search-type")).slideToggle("fast");
    });     

   $(document).on("click", ".btn-trip-add-cust", function (e) {      
        e.preventDefault(); 
  
        showModal({ url: "/widgets/Item-Edit/CustomPlace.aspx?&rid=" + getTripDetailRID(), saveText: "Save Custom Place", title: "Create Custom Place", 
            callback: function (modal) {saveCustomPlace(modal); }
         })   

    });     

    $(document).on("click", ".btn-trip-item-edit", function (e) {      
        e.preventDefault(); 
        //only cust places
        var p=$(this).parents(".detail-item");
        var ritype=p.data("ritype");
   
        if (ritype=="CUST"){
            var sTitle="Update Custom Place '"  + p.find("h4").html() +  "'";
              showModal({ url: "/widgets/Item-Edit/CustomPlace.aspx?&rid=" + getTripDetailRID() + '&p=' + p.data("riid"), saveText: "Save Custom Place", title: sTitle, 
             callback: function (modal) {
                saveCustomPlace(modal);
             } })   
         }
    });     

    $(document).on("click", ".btn-trip-item-comment", function (e) {      
        e.preventDefault(); 
           
        var p=$(this).parents(".detail-item");
        var sTitle="Add Comments for '"  + p.find("h4").html() +  "'";
        showModal({ url: "/widgets/Trip/Comments.aspx?&rid=" + getTripDetailRID() + '&p=' + p.data("riid"), saveText: "Save Comments", title: sTitle, 
        callback: function (modal) {  saveTripItemComments(modal)}  })

    });    
    
     $(document).on("click", ".btn-trip-item-delete", function (e) {      
        e.preventDefault(); 
        var p=$(this).parents(".detail-item");   
        var name= p.find("h4").html()
         if (confirm("Are you sure you want to remove item '" + name + "' from this trip?")) {
            removeTripItem(getTripDetailRID(), p.data("riid"), name,p.data("ritype"));
         }
            
    });     

    $("#sortableItems").sortable({
	    update:function () { 
			saveTripOrder();
	    } 
	});

 	$("#sortableItems").disableSelection();

    $(document).on("dragover", "#drop-area", function (e) {
        e.preventDefault();
    })

    $(document).on("click", "#drop-area", function (e) {
        var inputFile = $("#drop-input-file");
        if (!inputFile.data("clicked")) {
            inputFile.data("clicked", true);
            inputFile.click();                             
            inputFile.data("clicked", false);
        }
    });

    $(document).on("drop", "#drop-area", function (e) {
        e.preventDefault();
        var files = e.originalEvent.dataTransfer.files;
        doUploadTripImage(files)
    })
                                  
    $(document).on("change", "#drop-input-file", function (e) {
       $("#drop-input-file").data("clicked",false);
        var files = $(this)[0].files;
       doUploadTripImage(files)
    });
  
    $(document).on("click", ".remove-trip-image", function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (confirm("Are you sure you want to remove the image from this trip's cover page?")) {              
             var DTO = { 'rid': getTripDetailRID() } 
            DynaProxy.invoke("DeleteCoverImage", DTO, function (data) {
                $("#hdnImageName").val ("");
                $(".trip-image-div").html(data.imghtml);
                $(".trip-image-note").html(data.imgnote);
                showSystemNotification('Image has been removed. Remember to save your trip changes.');      
         
                }, function (data) {
                showSupportNotification("Unable to remove the trip's cover page image.");
            })  
        }       
    })

});

function doUploadTripImage(files){

      if (files.length > 0) {
            var reader = new FileReader();
            reader.onload = function (e) {
                var imageData = e.target.result;
                UploadTripImage(imageData, files[0].name, 'trip');
            };
            reader.readAsDataURL(files[0]);
        }
}
function UploadTripImage(imageData, imageName, mode) {
    var DTO = { 'imageData': imageData, 'imageName': imageName, 'mode':mode }
    DynaProxy.invoke("UploadTripImage", DTO, function (data) {
        if (data.msg!=""){
            showSystemNotification('Unable to upload the image. ' + data.msg ); 
        }else{
            showSystemNotification('Image has been uploaded. Remember to save your trip changes.');      
            $("#hdnImageName").val (data.fileurl);
            $(".trip-image-div").html(data.imghtml);
            $(".trip-image-note").html(data.imgnote);
      
            var someTabTriggerEl = document.querySelector('#trip-layout-image-tab')
            var tab = new bootstrap.Tab(someTabTriggerEl) 
            tab.show()
        }
    }, function (data) {
        showSupportNotification('Unable to upload the image.');  
    })
}
function saveTripOrder(){
    var s="|"; var rid= $("#sortableItems").data("rid");
    $("#sortableItems li").map(function() {s = s + $(this).data("riid") + "|"})            
    var DTO = { 'reportID': rid, 'placeKeys': s }            
        DynaProxy.invoke("UpdateReportSequence", DTO, function(data) {
    }, function(data) {
        showSupportNotification('Unable to save trip order.');  
    })
    return false;
}
function getTripDetailRID() {
    var s= $(".workspace").data("rid")
    if (s==undefined){ s="";}
    return s;
}
function getTripDetailName() {
    var s= $(".workspace").data("rname")
    if (s==undefined){ s="";}
    return s;
}

function doSendTrip(rid,saveText,title){
    showModal({ url: "/widgets/Trip/Send.aspx?rid=" + rid, saveText: saveText, showsecondaryBtn: true, secondaryBtnText: "Preview", secondaryBtnURL:"/Client/View?rid=" + rid, title: title, 
        callback: function (modal) { 
            if(sendTrip()){
                setTripDetailClean()
                refrehTripList(false);
                closeModal(modal); 
            }
        }
     });   
}    

                                         